import { makeObservable } from 'mobx';
import { Filtro } from './Filtro';

export default class FiltroCertidoesEncaminhadasPje extends Filtro {
    tipo = 'booleano';
    exibicao = 'checkbox';

    get label() {
        return 'Certidão encaminhada ao PJe';
    }

    constructor(props) {
        super(props);
        makeObservable(this);
    }

    getValorOpcao(registro) {
        return registro.certidaoJulgamentoTransferida;
    }

    getDescricao(valor) {
        return this.labelBooleanoSimNao(valor);
    }

    get isHabilitado() {
        return this.store.certidaoHabilitada && this.store.existeSessaoPJe;
    }
}
